import type {CallCost} from 'src/openapi/admin/models/CallCost';
import type {CallCostGroup} from 'src/openapi/admin/models/CallCostGroup';

export const restoreDefaultCallCost = (callGroups: CallCostGroup[], defaultCallCosts: CallCost[]) => {
    return callGroups.map(group => {
        return {
            ...group,
            callCoasts: group.callCoasts.map(callCost => {
                const defaultCost = defaultCallCosts.find(defaultCallCost => defaultCallCost.type === callCost.type);
                return defaultCost ? defaultCost : callCost;
            }),
        };
    });
};
